import AppLayout from '@/layouts/AppLayout.vue';
import ArticlesRoutes from '@/router/routes/connect/articles.route';
import SocialMediaRoutes from '@/router/routes/connect/socialmedia.route';
import WidgetsRoutes from '@/router/routes/connect/widgets.route';

const routes = [
  {
    path: '/connect',
    component: AppLayout,
    meta: { auth: true },
    children: [ArticlesRoutes, SocialMediaRoutes, WidgetsRoutes]
  }
];

export default routes;
